<template>
    <div class="grid-x grid-margin-x collapsed small-up-2 medium-up-4 gallery" v-if="images.length">

        <div class="cell" v-for="image in images" :key="image.id">

            <a :href="image.largeFileUrl" class="gallery-item">
                <img :src="image.smallFileUrl" :alt="image.caption">
            </a>

        </div>

    </div>
</template>
<script>
    import 'lightgallery';
    import 'lg-autoplay';
    import 'lg-zoom';
    import 'lg-thumbnail';
    import 'lg-fullscreen';
    export default {
        props: {
            images: {
                type: Array,
                required: true
            },
            options: {
                type: Object,
                required: false,
                default: () => { return {} }
            }
        },
        data() {
            return {}
        },
        mounted() {
            $(".gallery").lightGallery(
                Object.assign({selector: '.gallery-item'}, this.options)
            );
        }
    }
</script>